import { render, staticRenderFns } from "./WaiverTask.vue?vue&type=template&id=716c0c83&scoped=true"
import script from "./WaiverTask.vue?vue&type=script&lang=ts"
export * from "./WaiverTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716c0c83",
  null
  
)

export default component.exports